export interface StatusReportRecord {
  producerId: string;
  producerName: string;
  writingAgentId: string;
  writingAgentName: string;
  employerGroupName: string;
  /** null means "Open" — render as "Open" in the table */
  status: string | null;
  marketSegment: string;
  salesOffice: string;
  policyNumbers: string[];
}

/**
 * Client-side filter applied on top of API results.
 *
 * Internal users: matches producerName, writingAgentName, salesOffice, marketSegment.
 * External users: matches only producerName, writingAgentName.
 * Case-insensitive substring match. Returns data unchanged when filterValue is blank.
 */
export function filterReportResults(
  data: StatusReportRecord[],
  filterValue: string,
  isInternalUser: boolean,
): StatusReportRecord[] {
  if (!filterValue.trim()) return data;

  const lower = filterValue.toLowerCase();

  return data.filter((r) => {
    const baseMatch =
      r.producerName.toLowerCase().includes(lower) ||
      r.writingAgentName.toLowerCase().includes(lower);

    if (!isInternalUser) return baseMatch;

    return (
      baseMatch ||
      r.salesOffice.toLowerCase().includes(lower) ||
      r.marketSegment.toLowerCase().includes(lower)
    );
  });
}
